import { TypeDistrictData } from "../pages/regions/RegionPage";

export const CROP_LIST =[
    "Maize",
    "Coffee",
    "Tea"
]

export enum APP_STATUS {
    IDLE= "idle",
    PENDING= "pending",
    ERROR= "error",
    SUCCESS= "success",
}
export type TypeAppStatus ="idle" | "pending" | "error" | "success";
export const BASE_URL = process.env.REACT_APP_API_URL;

export type TypeDispatchResponse ={
    error?:any
    payload?:any
}

export type TypeValueChain={
    id:number
    name:string,
    description:string|null,
    created_at:string,
    districts:TypeDistrictData[]
    district_id?:string
    district?:TypeDistrictData
}

export type TypeDataSource={
    id:number | null
    name:string,
    website?:string,
    created_at?:string,
}


export type TypeDataItem={
    value:string | string[],
    data_source: string
}


export const  DEFAULT_DATA_ITEM={
    value:"",
    data_source: ""
}

export const  DEFAULT_DATA_ITEM_ARRAY={
    value:[],
    data_source: ""
}

export type TypeErrorResponse = { message: string, status: string }
